import React from 'react';

interface HelpsIconProps {
  className?: string;
  color?: string;
  size?: number;
}

const HelpsIcon: React.FC<HelpsIconProps> = ({ className = '', color = 'white', size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path
        d="M8 22.315C7.72 22.315 7.42998 22.245 7.16998 22.105C6.59998 21.805 6.25 21.205 6.25 20.565V19.1451C3.23 18.8351 1.25 16.615 1.25 13.435V7.43506C1.25 3.99506 3.56 1.68506 7 1.68506H17C20.44 1.68506 22.75 3.99506 22.75 7.43506V13.435C22.75 16.875 20.44 19.185 17 19.185H13.23L8.96997 22.0251C8.67997 22.2151 8.34 22.315 8 22.315ZM7 3.17505C4.42 3.17505 2.75 4.84505 2.75 7.42505V13.4251C2.75 16.0051 4.42 17.6751 7 17.6751C7.41 17.6751 7.75 18.0151 7.75 18.4251V20.5551C7.75 20.6851 7.83 20.7451 7.88 20.7751C7.93001 20.8051 8.03001 20.8351 8.14001 20.7651L12.59 17.8051C12.71 17.7251 12.86 17.6751 13.01 17.6751H17.01C19.59 17.6751 21.26 16.0051 21.26 13.4251V7.42505C21.26 4.84505 19.59 3.17505 17.01 3.17505H7Z"
        fill="currentColor"
      />
      <path
        d="M11.9998 12.1051C11.5898 12.1051 11.2498 11.7651 11.2498 11.3551V11.1451C11.2498 9.98514 12.0998 9.41513 12.4198 9.19513C12.7898 8.94513 12.9098 8.77514 12.9098 8.51514C12.9098 8.01514 12.4998 7.6051 11.9998 7.6051C11.4998 7.6051 11.0898 8.01514 11.0898 8.51514C11.0898 8.92514 10.7498 9.26514 10.3398 9.26514C9.92984 9.26514 9.58984 8.92514 9.58984 8.51514C9.58984 7.18514 10.6698 6.1051 11.9998 6.1051C13.3298 6.1051 14.4098 7.18514 14.4098 8.51514C14.4098 9.65514 13.5698 10.2251 13.2598 10.4351C12.8698 10.6951 12.7498 10.8651 12.7498 11.1451V11.3551C12.7498 11.7751 12.4098 12.1051 11.9998 12.1051Z"
        fill="currentColor"
      />
      <path
        d="M12 14.5951C11.58 14.5951 11.25 14.2551 11.25 13.8451C11.25 13.4351 11.59 13.0951 12 13.0951C12.41 13.0951 12.75 13.4351 12.75 13.8451C12.75 14.2551 12.42 14.5951 12 14.5951Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default HelpsIcon;
